import { FunctionComponent, useEffect, useMemo, useState } from 'react';
import GenericIcons from '../../components/generics/GenericIcons';
import { useLocation, useNavigate } from 'react-router-dom';
import * as WWDpages from './WhatWeDoPages';
import '../../css/PublicWhatWeDoPage.css';

export enum btnKey {
  acercaDe = 'acerca-de-la-plataforma',
  mapa = 'mapa-interactivo-de-redes',
  gestion = 'gestion-de-alojamiento-de-redes',
  capacidad = 'capacidad-de-alojamiento-de-redes',
  evaluacion = 'evaluacion-de-conexion-de-proyectos',
  puntos = 'puntos-robustos-de-red',
  estadisticas = 'estadisticas-del-sector'
}

const PublicWhatWeDoPage: FunctionComponent = () => {
  const whatWeDoBtns: Array<{
    key: btnKey;
    name: string;
    icon: string;
    component: JSX.Element;
  }> = useMemo(
    () => [
      {
        key: btnKey.acercaDe,
        name: 'Acerca de la plataforma',
        icon: 'InfoIcon',
        component: <WWDpages.Component01 />
      },
      {
        key: btnKey.mapa,
        name: 'Mapa Interactivo de Redes',
        icon: 'mapMarkedSolidLargeIcon',
        component: <WWDpages.Component02 />
      },
      {
        key: btnKey.gestion,
        name: 'Gestión de Datos de Redes',
        icon: 'databaseSolidLargeIcon',
        component: <WWDpages.Component03 />
      },
      {
        key: btnKey.capacidad,
        name: 'Capacidad de Alojamiento de Redes',
        icon: 'LightbulbFilamentIcon',
        component: <WWDpages.Component04 />
      },
      {
        key: btnKey.evaluacion,
        name: 'Evaluación de Conexión de Proyectos',
        icon: 'clipboardListSolidLargeIcon',
        component: <WWDpages.Component05 />
      },
      {
        key: btnKey.puntos,
        name: 'Puntos Robustos de Red',
        icon: 'LightningIcon',
        component: <WWDpages.Component06 />
      },
      {
        key: btnKey.estadisticas,
        name: 'Estadísticas del Sector',
        icon: 'chartBarSolidLargeIcon',
        component: <WWDpages.Component07 />
      }
    ],
    []
  );

  const navigate = useNavigate();
  const location = useLocation();
  const [whatWeDoBtnActive, setWhatWeDoBtnActive] = useState<btnKey>(btnKey.acercaDe);

  const optionParam = useMemo(() => {
    window.scrollTo(0, 0);
    const params = new URLSearchParams(location.search);
    const option = params.get('option');
    return option;
  }, [location.search]);

  useEffect(() => {
    const findBtn = whatWeDoBtns.find((btn) => btn.key === optionParam);
    if (findBtn) {
      setWhatWeDoBtnActive(findBtn.key);
    } else {
      setWhatWeDoBtnActive(btnKey.acercaDe);
    }
  }, [whatWeDoBtns, optionParam]);

  return (
    <div className='public-what-we-do-page-container vdr-wwd'>
      <header className='vdr-wwd-hero'>
        <div className='vdr-wwd-hero-inner'>
          <span className='vdr-eyebrow vdr-eyebrow--bar vdr-eyebrow--on-dark'>Herramientas</span>
          <h1 className='public-what-we-do-page-side-bar-title vdr-wwd-hero-title'>Qué hacemos</h1>
        </div>
      </header>
      <div className='vdr-wwd-body'>
        <div className='public-what-we-do-page-side-bar vdr-wwd-nav'>
          <span className='vdr-eyebrow vdr-wwd-nav-label' aria-hidden='true'>
            Secciones
          </span>
          <div className='public-what-we-do-page-side-bar-buttons-container vdr-wwd-nav-list'>
            {whatWeDoBtns.map((btn, idx) => (
              <button
                key={`public-home-page-what-we-do-btn-key-${idx}`}
                className={`interactive-button vdr-wwd-nav-item ${
                  btn.key === whatWeDoBtnActive ? 'interactive-button-active' : ''
                }`}
                onClick={() => navigate(`/public/que-hacemos?option=${btn.key}`)}>
                <GenericIcons icon={btn.icon} imageStyle={{ height: '2vw' }} />
                <span className='vdr-wwd-nav-name'>{btn.name}</span>
              </button>
            ))}
          </div>
        </div>
        <div className='public-what-we-do-page-content vdr-wwd-content'>
          {whatWeDoBtns.find((btn) => btn.key === whatWeDoBtnActive)?.component}
        </div>
      </div>
    </div>
  );
};

export default PublicWhatWeDoPage;
